import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import APIService from "@/services/APIService";
import localforage from 'localforage';

Vue.use(Vuex)

const supportSession = window.location.pathname.replace(/\/$/, '') === '/support-login'
  || new URLSearchParams(window.location.search).get('adminSupportLogin') === '1'
  || sessionStorage.getItem('adminSupportSession') === '1';
if (supportSession) sessionStorage.setItem('adminSupportSession', '1');

/* eslint-disable no-new */
const store = new Vuex.Store({
  plugins: supportSession ? [createPersistedState({ key: 'admin-vuex-support', storage: window.sessionStorage, paths: ['user', 'cacheSession'] })] : [
    createPersistedState({
      paths: ['user', 'cacheSession'],   // Hier spezifizieren wir, welche Pfad in localStorage gespeichert werden sollen
    }),
      createPersistedState(
      {
        storage: {
          getItem: key => localforage.getItem(key),
          setItem: (key, value) => localforage.setItem(key, value),
          removeItem: key => localforage.removeItem(key),
        },
        // API-backed lists are loaded lazily per login session.
        paths: ['options'],
      }
  )],
  modules: {
  },
  state: {
    user: null,
    users: [],
    startDate: null,
    endDate: null,
    managedUsers: [],
    routeLoading: false,
    cacheSession: null,
    cacheRevalidateOnNextView: false,
    options: {
      itemsPerPage: 15
    }
  },
  getters: {
    isLoggedIn: (state) => {
      return state.user !== null
    },
    hasRole: (state) => (role) => {
      return state?.user?.role === role
    },
    accessToken: (state) => {
      return state?.user?.tokens?.access?.token
    },
    refreshToken: (state) => {
      return state?.user?.tokens?.refresh?.token
    }
  },
  mutations: {
    setDates(state, dates) {
      state.startDate = dates.startDate;
      state.endDate = dates.endDate;
    },
    updateUser(state, data) {
      const {user, tokens} = data
      state.user = user
      state.user.tokens = tokens
      state.users = []
      state.managedUsers = []
      state.cacheSession = user.id
      state.cacheRevalidateOnNextView = true
    },
    updateTokens(state, tokens) {
      state.user = { ...state.user, tokens }
    },
    async logout(state) {
      state.user = null
      state.users = []
      state.managedUsers = []
      state.cacheSession = null
      state.cacheRevalidateOnNextView = false
    },
    updateUsers(state,users) {
      state.users = users
    },
    updateManagers(state,managers) {
      state.user.managers = managers
    },
    updateManagedUsers(state,managedUsers) {
      state.managedUsers = managedUsers
    },
    setRouteLoading(state, isLoading) {
      state.routeLoading = isLoading
    },
    setCacheRevalidateOnNextView(state, shouldRevalidate) {
      state.cacheRevalidateOnNextView = shouldRevalidate
    },
    updateItemsPerPage(state, itemsPerPage) {
      state.options = { ...state.options, itemsPerPage }
    },
    resetManagedUsers (state) {
      if(state.managedUsers)
        state.managedUsers = [];
    }
  },
  actions: {
    login({commit}, {email, password}){
      return APIService.login(email, password).then((user) => {
        commit('updateUser', user)
      })
    },
    async logout({commit, getters, state}){
      if(getters.isLoggedIn) {
        if (!state.user.supportLogin) await APIService.logout(store.getters.refreshToken)
        commit('logout')
      }
    },
    refreshToken({commit,state}) {
      if (state.user?.supportLogin) return Promise.reject(new Error('Support session cannot be refreshed'))
      const token = state?.user?.tokens?.refresh?.token ?? 'invalid'
      return APIService.refreshToken(token).then(tokens => {
        commit('updateTokens', tokens)
        return tokens
      })
    },
    fetchUsers({commit}, options = {}) {
      const requestOptions = typeof options === 'boolean' ? {force: options} : options
      const updateUsers = (users) => {
        //console.log("users", users)
        for(let i=0; i<users.length; i++){
          users[i].completeName = users[i].firstName + " " + users[i].lastName;
        }
        commit('updateUsers', users)
        if (requestOptions.onUpdate) {
          requestOptions.onUpdate(users)
        }
      }

      return APIService.getUsers({
        ...requestOptions,
        onUpdate: updateUsers
      }).then((users) => {
        updateUsers(users)
      })
    },
    fetchManagedUsers({commit, state}) {
      return APIService.getManagedUsers(state.user.id).then((users) => {
        commit('updateManagedUsers', users)
      })
    },
  }
})

export default store
